<template>
  <div class="frequent-questions__banner">
    <div>
      <strong> Ainda precisa de ajuda? </strong>
    </div>
    <div>
      <span>
        Podemos te atender melhor pelo <br>
        telefone 0800-643-8100 Opção 3.
      </span>
    </div>
  </div>
</template>

<script>
export default {
  name: 'FrequentQuestionsBanner'
}
</script>

<style lang="scss">
.frequent-questions {
  &__banner {
    margin-top: 50px;
    background: linear-gradient(91.08deg, #7f1a54 20.16%, #a4347d 106.23%);
    border-radius: 5px;
    padding: 20px;
    display: flex;
    align-items: center;
    justify-content: center;
    position: relative;
    background-repeat: no-repeat;
    &:after {
      content: '';
      width: 127px;
      height: 127px;
      background: url('/static/images/background-banner-help-center.svg');
      position: absolute;
      left: 0;
      background-repeat: no-repeat;
      background-size: contain;
    }
    span {
      color: #ffffff;
      font-size: 13px;
      line-height: 1.25;
      letter-spacing: 0;
    }
    div:first-child {
      border-right: 1px solid rgba(255, 255, 255, 0.35);
      padding-right: 20px;
      margin-right: 20px;
      line-height: 56px;
      strong {
        font-style: normal;
        font-weight: 500;
        font-size: 18px;
        color: #ffffff;
      }
    }
  }
}
</style>
